export const stylesExtensions = [
    '.css',
    '.scss',
    '.sass',
    '.less',
    '.pcss',
    '.sss',
    '.styl',
    '.stylus',
];
